import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollableContainer } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useCallback } from 'react';
import { MediaService } from '../../../services/media/MediaService';
import { StreamrAppService } from '../../../services/streamrapp/StreamrAppService';
import { BottomCenter, Popup, TopCenter } from '../../../utils/popups';
import { DeviceSelector, DeviceSelectorContainer, DeviceSelectorPopupRoot, } from './DeviceSelectorPopup';
export const AddCameraSelectorPopup = ({ reject, resolve, variant, ...props }) => {
    const videoDevices = MediaService.getOutput().useVideoDevices();
    const hasPermission = MediaService.getOutput().useCameraPermissioned();
    const onDeviceSelect = useCallback((device) => {
        StreamrAppService.getNotificationInterface().notifyAddCamera(device.deviceId);
        resolve();
    }, [resolve]);
    const onAllowAccess = useCallback(() => {
        MediaService.getNotificationInterface().notifyMediaPermissionsRequested({ video: true });
        resolve();
    }, [resolve]);
    const translateFn = variant === 'top-center' ? TopCenter : BottomCenter;
    return (_jsx(DeviceSelectorPopupRoot, { className: variant, reject: reject, translateFn: translateFn, ...props, children: _jsx(ScrollableContainer, { children: _jsx(DeviceSelectorContainer, { children: _jsx(DeviceSelector, { label: "Add camera", devicesList: videoDevices, selectedDevice: undefined, onDeviceSelect: onDeviceSelect, isEnabled: true, onEnableChange: () => { }, onClose: reject, hasAccessToDevices: hasPermission, onAllowAccess: onAllowAccess }) }) }) }));
};
const addCameraPopup = Popup.create(AddCameraSelectorPopup);
export function selectAddCamera(options) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await addCameraPopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
